/**
 * Python 标准库模块列表 & 常见第三方包
 * 数据来源: hallucination.ts
 */

export const PYTHON_STDLIB: ReadonlySet<string> = new Set([
  // 核心运行时
  "__future__",
  "os",
  "sys",
  "re",
  "json",
  "csv",
  "math",
  "random",
  "datetime",
  "time",
  "collections",
  "itertools",
  "functools",
  "operator",
  "pathlib",
  "shutil",
  "subprocess",
  "threading",
  "multiprocessing",
  "logging",
  "argparse",
  "unittest",
  "typing",
  "dataclasses",
  "abc",
  "io",
  "hashlib",
  "hmac",
  "secrets",
  "base64",
  "struct",
  "pickle",
  "copy",
  "pprint",
  "textwrap",
  "string",
  "enum",
  "contextlib",
  "traceback",
  "warnings",
  "weakref",
  "types",
  "inspect",
  "dis",
  "gc",
  "site",
  "codecs",
  "unicodedata",
  "locale",
  "gettext",
  "calendar",
  "heapq",
  "bisect",
  "array",
  "queue",
  "socket",
  "http",
  "urllib",
  "xml",
  "html",
  "email",
  "ftplib",
  "smtplib",
  "telnetlib",
  "ssl",
  "select",
  "selectors",
  "asyncio",
  "concurrent",
  "xmlrpc",
  "ipaddress",
  "uuid",
  "platform",
  "ctypes",
  "signal",
  "mmap",
  "tempfile",
  "glob",
  "fnmatch",
  "linecache",
  "stat",
  "fileinput",
  "configparser",
  "toml",
  "zipfile",
  "tarfile",
  "gzip",
  "bz2",
  "lzma",
  "zlib",
  "sqlite3",
  "dbm",
  "token",
  "tokenize",
  "ast",
  "symtable",
  "compileall",
  "pdb",
  "profile",
  "timeit",
  "trace",
  "resource",
  // 网络
  "http.server",
  "http.client",
  "http.cookies",
  "http.cookiejar",
  "urllib.request",
  "urllib.parse",
  "urllib.error",
  "urllib.robotparser",
  "xml.etree.ElementTree",
  "xml.dom",
  "xml.sax",
  "xml.parsers",
  "html.parser",
  "html.entities",
  "socketserver",
  "webbrowser",
  "xmlrpc.client",
  "xmlrpc.server",
  "poplib",
  "imaplib",
  "nntplib",
  "smtplib",
  "asyncio",
  "asyncio.subprocess",
  "asyncio.streams",
  // 数据与格式
  "csv",
  "json",
  "toml",
  "configparser",
  "plistlib",
  "email.mime",
  "email.mime.text",
  "email.mime.base",
  "email.mime.multipart",
  "email.header",
  "email.utils",
  "email.message",
  "mailcap",
  "mailbox",
  "mimetypes",
  "netrc",
  "xdrlib",
  "curses",
  "curses.textpad",
  // 加密与安全
  "hashlib",
  "hmac",
  "secrets",
  "ssl",
  // 数据库
  "sqlite3",
  "dbm",
  "dbm.dumb",
  "dbm.gnu",
  "dbm.ndbm",
  // 文件与目录
  "tempfile",
  "glob",
  "fnmatch",
  "linecache",
  "stat",
  "fileinput",
  "shutil",
  "pathlib",
  "os.path",
  // 系统与进程
  "atexit",
  "signal",
  "resource",
  "syslog",
  "posix",
  "nt",
  "pwd",
  "spwd",
  "grp",
  "nis",
  // 调试与测试
  "unittest.mock",
  "unittest.runner",
  "unittest.suite",
  "unittest.case",
  "doctest",
  "pydoc",
  "compileall",
  "py_compile",
  "bdb",
  "pdb",
  "profile",
  "cProfile",
  "pstats",
  "timeit",
  "trace",
  "faulthandler",
  "tracemalloc",
  "warnings",
  // 国际化
  "gettext",
  "locale",
  "codecs",
  "encodings",
  // 数据类型与工具
  "collections.abc",
  "collections.defaultdict",
  "collections.OrderedDict",
  "collections.Counter",
  "collections.deque",
  "collections.namedtuple",
  "collections.ChainMap",
  "typing",
  "dataclasses",
  "enum",
  "numbers",
  "decimal",
  "fractions",
  "statistics",
  "cmath",
  "math",
  "array",
  "bisect",
  "heapq",
  "sched",
  "weakref",
  "weakref.WeakKeyDictionary",
  "weakref.WeakValueDictionary",
  "types",
  "types.MappingProxyType",
  "types.SimpleNamespace",
  "functools",
  "functools.lru_cache",
  "functools.partial",
  "functools.wraps",
  "itertools",
  "itertools.chain",
  "itertools.combinations",
  "operator",
  "operator.attrgetter",
  "operator.itemgetter",
  "copy",
  "copy.deepcopy",
  "pprint",
  "textwrap",
  "string",
  "re",
  "difflib",
  // 并发
  "contextvars",
  "threading",
  "threading.Thread",
  "threading.Lock",
  "threading.Event",
  "threading.Condition",
  "threading.Semaphore",
  "threading.Barrier",
  "multiprocessing",
  "multiprocessing.Pool",
  "multiprocessing.Queue",
  "concurrent.futures",
  "concurrent.futures.ThreadPoolExecutor",
  "concurrent.futures.ProcessPoolExecutor",
  "queue",
  "queue.Queue",
  "queue.LifoQueue",
  "queue.PriorityQueue",
  "subprocess",
  "subprocess.run",
  "subprocess.Popen",
  "asyncio",
  "asyncio.run",
  "asyncio.gather",
  "asyncio.create_task",
  // 其他
  "zoneinfo",
  "venv",
  "zipapp",
  "importlib",
  "importlib.metadata",
  "importlib.resources",
  "pkgutil",
  "modulefinder",
  "runpy",
  "sysconfig",
  "site",
  "code",
  "codeop",
  "crypt",
  "curses",
  "curses.ascii",
  "turtle",
  "tkinter",
  "colorsys",
  "imghdr",
  "sndhdr",
  "wave",
  "chunk",
  "aifc",
  "sunau",
  "audioop",
  "msvcrt",
  "winreg",
  "winsound",
  "posixpath",
  "ntpath",
  "genericpath",
  "optparse",
  "getpass",
  "cmd",
  "shlex",
  "tty",
  "pty",
  "termios",
  "readline",
  "rlcompleter",
]);

export const PYTHON_COMMON_PACKAGES: ReadonlySet<string> = new Set([
  // Web 框架
  "flask", "django", "fastapi", "tornado", "bottle", "aiohttp", "sanic", "starlette",
  // HTTP 客户端
  "requests", "httpx", "urllib3", "aiohttp",
  // 数据科学
  "numpy", "pandas", "scipy", "sklearn", "scikit_learn", "matplotlib", "seaborn",
  "plotly", "bokeh", "statsmodels", "sympy",
  // 机器学习 / AI
  "torch", "tensorflow", "keras", "transformers", "openai", "anthropic",
  "langchain", "tiktoken", "huggingface_hub", "diffusers", "accelerate",
  // 文档处理
  "docx", "python_docx", "openpyxl", "xlrd", "xlwt", "pdfplumber", "pypdf",
  "reportlab", "fpdf", "weasyprint", "markdown", "beautifulsoup4", "bs4",
  "lxml", "html5lib",
  // 环境与配置
  "dotenv", "python_dotenv", "pydantic", "hydra", "click", "typer", "rich",
  "toml", "pyyaml", "yaml", "configparser",
  // 数据库
  "sqlalchemy", "psycopg2", "pymysql", "mysql", "redis", "mongo", "pymongo",
  "alembic", "peewee", "tortoise",
  // 认证与安全
  "bcrypt", "passlib", "jose", "pyjwt", "jwt", "cryptography", "paramiko",
  "oauthlib", "authlib",
  // 测试
  "pytest", "mock", "unittest", "nose", "coverage", "tox", "hypothesis",
  // 异步
  "celery", "redis", "dramatiq", "rq",
  // 图像处理
  "pillow", "PIL", "opencv", "cv2", "imageio", "wand", "easyocr", "pytesseract",
  // 命令行
  "argcomplete", "colorama", "tqdm",
  // 序列化
  "marshmallow", "cattrs", "attrs", "dataclasses_json",
  // 日志与监控
  "sentry_sdk", "structlog", "loguru",
  // 其他常用
  "dateutil", "pytz", "arrow", "pendulum", "croniter",
  "jinja2", "mako", "cherrypy",
  "fabric", "ansible", "boto3", "botocore",
  "psutil", "watchdog", "schedule",
  "tenacity", "retry", "deprecation",
  "cachetools", "functools_cache",
  "more_itertools", "toolz",
  "inflect", "inflection",
  "python_dateutil", "six", "future",
  "setuptools", "pip", "wheel",
  "uvicorn", "gunicorn", "werkzeug",
]);
